/* eslint-disable @typescript-eslint/no-explicit-any */
import InputText from "primevue/inputtext";
import InputNumber from "primevue/inputnumber";
import Dropdown from "primevue/dropdown";
import Button from "primevue/button";
import Checkbox from "primevue/checkbox";
import ProgressBar from "primevue/progressbar";
import BlockUI from "primevue/blockui";
import MultiSelect from "primevue/multiselect";
import Textarea from "primevue/textarea";

export default {
  install: (app: any) => {
    [
      InputText,
      InputNumber,
      Dropdown,
      Button,
      Checkbox,
      ProgressBar,
      BlockUI,
      MultiSelect,
      Textarea,
    ].forEach((Component: any) => {
      app.component(Component.name, Component);
    });
  },
};
